<div class="title">
    <span> {{ title }} </span>
</div>
<div class="markets">
    <span class="market_1">{{ teaserBetMessages?.messages?.Points }}</span>
    <span class="market_2">{{ teaserBetMessages?.messages?.Newline }}</span>
</div>
